import React from "react";

export const AppIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M5 1a2 2 0 0 0-1.414.586l-3 3A2 2 0 0 0 .48 7.302l6 7a2 2 0 0 0 3.038 0l6-7a2 2 0 0 0-.105-2.716l-3-3A2 2 0 0 0 11 1zm3 5a3 3 0 0 0 3-3 3 3 0 0 0 3 3 3 3 0 0 0-3 3 3 3 0 0 0-3-3z"
        clip-rule="evenodd"
      />
    </svg>
  );
};
